import React, { useMemo } from 'react';
import { AudioContext, AudioTimeContext } from './Audio.context';
import { useDuration, usePlayPause, useAudioRef, useSrcChanged, useAudioTime, useSpeed, useSetDeviceId, useAudioError } from './hooks';
export function Audio(_ref) {
  var src = _ref.src,
      sinkId = _ref.sinkId,
      children = _ref.children;
  // Creating a new HTMLAudioElement.
  var audioRef = useAudioRef(); // Providing the duration of the audio once it was loaded.

  var duration = useDuration(audioRef); // Proving all the operation/data on the currentTime of the audio.

  var _useAudioTime = useAudioTime(audioRef),
      seek = _useAudioTime.seek,
      rewind = _useAudioTime.rewind,
      fastForward = _useAudioTime.fastForward,
      currentTime = _useAudioTime.currentTime; // Providing the play/pause data/operation.


  var _usePlayPause = usePlayPause(audioRef),
      isPlaying = _usePlayPause.isPlaying,
      togglePlay = _usePlayPause.togglePlay,
      play = _usePlayPause.play,
      pause = _usePlayPause.pause; // Providing control of the playback speed.


  var _useSpeed = useSpeed(audioRef),
      setSpeed = _useSpeed.setSpeed,
      speed = _useSpeed.speed; // subscribe to error event


  var _useAudioError = useAudioError(audioRef),
      error = _useAudioError.error,
      setError = _useAudioError.setError; // Replacing src when "src" prop has changed.


  useSrcChanged(src, audioRef, seek, setSpeed, setError); // Define the output speaker device
  // (Not supported by all browsers https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/setSinkId#browser_compatibility)

  useSetDeviceId(audioRef, sinkId);
  var context = useMemo(function () {
    return {
      duration: duration,
      isPlaying: isPlaying,
      play: play,
      pause: pause,
      togglePlay: togglePlay,
      seek: seek,
      fastForward: fastForward,
      rewind: rewind,
      setSpeed: setSpeed,
      speed: speed,
      error: error
    };
  }, [play, pause, isPlaying, togglePlay, duration, seek, fastForward, rewind, setSpeed, speed, error]);
  return /*#__PURE__*/React.createElement(AudioContext.Provider, {
    value: context
  }, /*#__PURE__*/React.createElement(AudioTimeContext.Provider, {
    value: {
      currentTime: currentTime
    }
  }, children));
}